import React from "react";

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  action?: React.ReactNode;
}

/**
 * PageHeader - Reusable page header component
 * Used for consistent page titles across the app (Dashboard, Emails, etc.)
 */
const PageHeader: React.FC<PageHeaderProps> = ({ title, subtitle, action }) => {
  return (
    <div className="su-page-header">
      <div className="su-page-header-left">
        <h1 className="su-page-header-title">{title}</h1>
        {subtitle && <p className="su-page-header-subtitle">{subtitle}</p>}
      </div>
      {action && <div className="su-page-header-action">{action}</div>}
    </div>
  );
};

export default PageHeader;



